var service = {};
service.handleResponse = handleResponse;
export default service;

function handleResponse(response) {
  /*
  if (response.ok !== null) {
    if (response.ok === false) {
      FlashService.Error(response.message, true);
      $rootScope.isLoading = false;
      if (response.messagecode !== null && response.messagecode === 11552) {
        $location.url("/login");
      }
    }
  }*/
}
